var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHiTechProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2551_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824 500.5C824 475.531 814.99 454.587 797.952 438.915L557.124 198.447C541.596 184.237 522.546 177 500.5 177C322.144 177 177 322.12 177 500.5C177 678.88 322.144 824 500.5 824C678.856 824 824 678.856 824 500.5ZM200.963 500.5C200.963 335.06 335.06 200.963 500.5 200.963C583.22 200.963 566.087 326.529 620.315 380.685C674.471 434.889 800.037 417.78 800.037 500.5C800.037 665.94 665.916 800.037 500.5 800.037C335.084 800.037 200.963 665.94 200.963 500.5Z",
    fill: "url(#paint0_linear_2551_5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint1_linear_2551_5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint2_linear_2551_5)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2551_5",
    x1: 703,
    y1: 309.498,
    x2: 242,
    y2: 786.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217377,
    stopColor: "#BBD8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604039,
    stopColor: "#1B3F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#0D2927"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2551_5",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2551_5",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2551_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHiTechProtection);
export default __webpack_public_path__ + "static/media/Logo_HiTechProtection.dcb0009790ab675879c0eac2db9431da.svg";
export { ForwardRef as ReactComponent };